import k from '../k'
import gameOver from './gameOver'

export default (y: number) => {
  const voidObj = k.add([
    k.rect(1500, 10),
    k.opacity(0),
    k.pos(k.vec2(-200, y)),
    k.body({ isStatic: true }),
    k.area()
  ])

  voidObj.onCollide('robot', () => gameOver('to the void!'))
}
